import { useRouteError } from "react-router-dom";

type ErrorResponse = {
  data: unknown;
  status: number;
  statusText: string;
  message?: string;
};

const errorCheck = (error: unknown): error is ErrorResponse => {
  return (
    typeof error === "object" &&
    error !== null &&
    "data" in error &&
    "status" in error &&
    "statusText" in error
  );
};

export function ErrorPage() {
  const error: unknown = useRouteError();
  console.log(error);

  if (errorCheck(error)) {
    return (
      <div id="error-page" style={{ color: "#000" }}>
        <h1>Oops! Page not found</h1>
        <p>Sorry the route you are looking for does not exist.</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </div>
    );
  } else {
    return null;
  }
}
